import { createRouter, createWebHistory  } from 'vue-router'
import { ElLoading } from 'element-plus'
// import store from '@/store'
const routes = [
  {
    path: '/',
    name: '首页',
    component: ()=> import('../views/index'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/login',
    name: '登錄',
    component: ()=> import('../views/login'),
    meta: {
      IsLog: false,
      showNav: false,
    }
  },
  {
    path: '/editPwd',
    name: '修改密码',
    component: ()=> import('../views/editPwd'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/agentManagement',
    name: '代理管理',
    component: ()=> import('../views/manage/index'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/ManagementTree',
    name: '代理树',
    component: ()=> import('../views/manage/tree'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/winorlose',
    name: '輸贏報表',
    component: ()=> import('../views/report/winorlose'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/betAnalysis',
    name: '玩家投注分析',
    component: ()=> import('../views/report/betAnalysis'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/memberBet',
    name: '投注記錄',
    component: ()=> import('../views/report/memberBet'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/gameResult',
    name: '游戏结果',
    component: ()=> import('../views/report/gameResult'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/actingLog',
    name: '代理額度記錄',
    component: ()=> import('../views/report/actingLog'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/balanceRecord',
    name: '玩家額度記錄',
    component: ()=> import('../views/report/balanceRecord'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/balanceReport',
    name: '代理商額度報表',
    component: ()=> import('../views/report/balanceReport'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/agentMonthReport',
    name: '代理纍計報表',
    component: ()=> import('../views/report/agentMonthReport'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/giftRecord',
    name: '贈禮記錄',
    component: ()=> import('../views/report/giftRecord'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/ipWhitelist',
    name: '登入IP白名單',
    component: ()=> import('../views/report/ipWhitelist'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/ipSearch',
    name: 'IP查詢',
    component: ()=> import('../views/report/ipSearch'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  },
  {
    path: '/logManagement',
    name: '操作日志',
    component: ()=> import('../views/report/logManagement'),
    meta: {
      IsLog: true,
      showNav: true,
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})
var loading
router.beforeEach(() => {

  loading = ElLoading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.7)'
  })
//   if (store.state.token) {
//     const isSeller = localStorage.getItem('isSeller')
//     if (isSeller === '1' && to.meta.isSeller === false) {
//       router.push('/managerIndex')
//     }
//     if (to.path !== '/login' && to.path !== '/res') {
//       next()
//     } else {
//       router.go(-1)
//     }
//   } else {
//     if (to.path === '/login' || to.path === '/res' || !to.meta.IsLog) {
//       next()
//     } else {
//       router.push('/login')
//     }
//   }
})
router.afterEach(() => {
  // 模拟加载时间，或等待主要数据加载完成
  setTimeout(() => {
    loading.close()
  }, 500)
});
export default router
